<template lang="html">

    <div class="politica-de-privacidad">
  
      <section class="intro-legales column-center launch">
  
        <h2 class="subtitle-intro">
          <span>{{$t("vistas.politica_proteccion")}}</span>
        </h2>
  
      </section> 
  
      <section class="textos-legales container">
        
  
          <p>Дирекция / Руководящий орган <strong>ALDONZA GOURMET S.A.U.</strong> (далее — лицо, ответственное за процесс), берет на себя максимальную ответственность и приверженность установлению, внедрению и поддержанию настоящей Политики защиты данных, гарантируя постоянное совершенствование лица, отвечающего за процесс, с целью достижения совершенства в отношении соблюдения Регламента (ЕС) 2016/679 Европейского парламента и Совета от 27 апреля 2016 г. о защите физических лиц в отношении обработки персональных данных и свободного обращения этих данных и, следовательно, которые отменяет Директиву 95/46/CE (Общее положение о защите данных) (DOUE L 119/1, 05-04-2016) и испанские правила защиты персональных данных (Органический закон, законодательство, относящееся к конкретному сектору, и правила его разработки).</p>
  
  <p>Политика защиты данных <strong>ALDONZA GOURMET S.A.U.</strong> основывается на принципе проактивной ответственности, в соответствии с которым контролер несет ответственность за соблюдение нормативно-правовой базы, регулирующей указанную Политику, и способен продемонстрировать это перед компетентными контролирующими органами.</p>
  
  <p>В этом смысле лицо, ответственное за обработку, будет руководствоваться следующими принципами, которые должны служить всем его сотрудникам в качестве руководства и системы отсчета при обработке персональных данных:</p>
  
  <p>1.  <u>Защита данных по дизайну:</u> Лицо, ответственное за работу с данными, будет применять как при определении видов деятельности, так и во время самого процесса соответствующие технические и организационные меры, такие как псевдонимизация, предназначенные для эффективного применения принципов защиты данных, таких как минимизация данные и интегрировать необходимые гарантии в процесс работы с данными.</p>
  
  <p>2.  <u>Защита данных по умолчанию:</u> Ответственный за процесс защиты данных будет применять соответствующие технические и организационные меры, чтобы гарантировать, что по умолчанию обрабатываются только те персональные данные, которые необходимы для каждой из конкретных целей обработки.</p>
  
  <p>3.  <u>Защита данных в живом цикле информации:</u> Меры, гарантирующие защиту персональных данных, будут применяться в течение всего жизненного цикла информации.</p>
  
  <p>4.  <u>Законность, лояльность и прозрачность:</u> Персональные данные будут обрабатываться законным, лояльным и прозрачным образом по отношению к заинтересованному лицу.</p>
  
  <p>5.  <u>Целевое ограничение:</u> персональные данные будут собираться для конкретных, явных и законных целей и не будут обрабатываться в дальнейшем способом, несовместимым с этими целями.</p>
  
  <p>6.  <u>Минимизация данных:</u> персональные данные будут адекватными, уместными и ограниченными тем, что необходимо в связи с целями, для которых они обрабатываются.</p>
   
  <p>7.  <u>Точность:</u> персональные данные будут точными и, при необходимости, актуальными; Будут предприняты все разумные шаги для обеспечения того, чтобы личные данные, которые являются неточными в отношении целей, для которых они обрабатываются, были удалены или исправлены без промедления.</p>
  
  <p>8.  <u>Ограничение срока хранения:</u> персональные данные будут храниться таким образом, чтобы идентификация заинтересованных лиц разрешалась не дольше, чем это необходимо для целей обработки персональных данных.</p>
  
  <p>9.  <u>Честность и конфиденциальность:</u> персональные данные будут обрабатываться таким образом, чтобы обеспечить надлежащую безопасность персональных данных, включая защиту от несанкционированной или незаконной обработки и от случайной потери, уничтожения или повреждения, путем применения соответствующих технических или организационных мер.</p>
  
  <p>10. <u>Информация и обучение:</u> Одним из ключей, гарантирующих защиту персональных данных, является обучение и информация, предоставляемая персоналу, занимающемуся их обработкой. В течение жизненного цикла информации весь персонал, имеющий доступ к данным, будет должным образом обучен и проинформирован о своих обязанностях в отношении соблюдения правил защиты данных.</p>
  
  <p>Политика защиты данных <strong>ALDONZA GOURMET S.A.U.</strong> она сообщается всему персоналу лицом, ответственным за обработку данных, и предоставляется всем заинтересованным сторонам.</p>
  
  <p>Как следствие,  в процесс обработки, хранения и защиты данных вовлекается весь персонал и лица, ответственные за обработку, которые должны знать и принимать ее, обрабатывая ее как свою собственную. Причем каждый участник несет ответственность за применение и проверку правил защиты данных, применимых к ней, а также должен выявлять и предлагать возможности для улучшения, которые он считает целесообразными, с целью достижения совершенства в отношении соблюдения данной Политики.</p>
  
  <p>Настоящая Политика будет рассмотрена Дирекцией / Руководящим органом. <strong>ALDONZA GOURMET S.A.U</strong>, столько раз, сколько это будет необходимо, чтобы всегда адаптировать ее к действующим положениям о защите персональных данных.</p>
  
      </section>
  
  
  
  
    </div>
  </template>
  
  <script lang="js">
    export default  {
      name: 'politica-de-proteccion-datos',
      props: [],
      mounted() {
  
      },
      data() {
        return {
  
        }
      },
      methods: {
  
      },
      computed: {
  
      }
  }
  </script>
  
  <style scoped lang="scss">
    .politica-de-privacidad {
  
    }
  </style>
  


// WEBPACK FOOTER //
// src/components/views/politica-de-privacidad-ru.vue